<script>
import HeaderNavLink from '@/components/HeaderNavLink.vue';

export default {
    components: { HeaderNavLink },
    props: {
        component: {
            type: Object,
            default: () => { },
        },
    },
};
</script>

<template>
    <div class="flex flex-col gap-2">
        <h5
            v-if="component.title"
            class="text-base font-bold"
        >
            {{ component.title }}
        </h5>
        <template v-if="component.link_items?.length > 0">
            <HeaderNavLink
                v-for="(link, index) in component.link_items"
                :key="index"
                :url="link.url"
                class="flex items-center gap-4 text-base"
            >
                <img
                    v-lazy="`https://content.bubblegumballoons.com/assets/${link.image}?format=webp&quality=60&width=128`"
                    :alt="link.label"
                    class="w-12 h-12 rounded-full"
                >
                <span>
                    {{ link.label }}
                </span>
            </HeaderNavLink>
        </template>
        <template v-else>
            <HeaderNavLink
                v-for="(link, index) in component.links"
                :key="index"
                :url="link.url"
                class="text-base"
            >
                {{ link.label }}
            </HeaderNavLink>
        </template>
    </div>
</template>

<style scoped lang="scss"></style>
